module.exports = __webpack_public_path__ + "as.svg?1d7901fc863b36cc55cea528a7efc460";